import Skeleton from "react-loading-skeleton";
import { Heading } from "@/components/catalyst/Heading";
import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/catalyst/Table";

export function PaymentMethodsSkeleton() {
	return (
		<div>
			<div className="flex items-center justify-between">
				<Heading level={2}>Payment Methods</Heading>
			</div>

			<Table className="mt-8">
				<TableHead>
					<TableRow>
						<TableHeader>Name</TableHeader>
						<TableHeader>Card</TableHeader>
						<TableHeader>Created</TableHeader>
						<TableHeader>
							<span className="sr-only">Actions</span>
						</TableHeader>
					</TableRow>
				</TableHead>
				<TableBody>
					{Array.from({ length: 3 }).map((_, i) => (
						<TableRow key={i}>
							<TableCell>
								<Skeleton width={140} />
							</TableCell>
							<TableCell>
								<Skeleton width={140} />
							</TableCell>
							<TableCell>
								<Skeleton width={100} />
							</TableCell>
							<TableCell>
								<div className="flex items-center justify-end">
									<Skeleton width={20} height={20} circle />
								</div>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</div>
	);
}
